export const BACKEND_URL = "https://rewards-backend.superviptiers.com";
// export const BACKEND_URL = "https://rewards-staging-backend.superviptiers.com";
// export const BACKEND_URL = "http://localhost:58644";
